/**
 * Session Utilities
 * Helper functions for normalizing and working with session data
 */

/**
 * Normalize session data from API to consistent format
 * Handles different field name variations
 */
export function normalizeSession(session) {
  if (!session) return null;
  
  // Extract tutor name from various possible locations
  let tutorName = null;
  let tutorId = null;
  
  // Direct fields
  if (session.tutor_name) tutorName = session.tutor_name;
  else if (session.teacher_name) tutorName = session.teacher_name;
  else if (session.instructor_name) tutorName = session.instructor_name;
  else if (session.employee_name) tutorName = session.employee_name;
  else if (typeof session.tutor === 'string') tutorName = session.tutor;
  
  // Nested tutor object
  if (!tutorName && session.tutor) {
    if (typeof session.tutor === 'object') {
      tutorName = session.tutor.name || session.tutor.tutor_name || session.tutor.employee_name;
      tutorId = session.tutor.id || session.tutor.tutor_id || session.tutor.employee_id;
    }
  }
  
  // Nested employee object
  if (!tutorName && session.employee) {
    if (typeof session.employee === 'object') {
      tutorName = session.employee.name || session.employee.employee_name;
      tutorId = session.employee.id || session.employee.employee_id;
    }
  }
  
  // Tutor ID
  if (!tutorId) {
    tutorId = session.tutor_id || session.teacher_id || session.instructor_id || session.employee_id;
  }
  
  return {
    id: session.id,
    subject: session.subject || session.subject_name || 'Subject',
    subject_id: session.subject_id,
    batches: session.batches || '',
    period: session.period || '',
    period_id: session.period_id,
    time_start: session.time_start || session.start_time || '',
    time_end: session.time_end || session.end_time || '',
    session_date: session.session_date || session.date || '',
    session_datetime: session.session_datetime,
    weekday: session.weekday || '',
    state: session.state || session.status || 'pending',
    can_mark: session.can_mark || false,
    can_view: session.can_view || false,
    attendance_summary: session.attendance_summary || session.summary || null,
    tutor_name: tutorName,
    tutor_id: tutorId,
    tutor_assignment_id: session.tutor_assignment_id || null,
    campus: session.campus || '',
    campus_name: session.campus_name || session.campus_label || session.campus || '',
    teaching_week: session.teaching_week || null,
    teaching_week_label: session.teaching_week_label || (session.teaching_week ? `Week ${session.teaching_week}` : '')
  };
}

/**
 * Format batches string to array
 */
export function getBatchesArray(batches) {
  if (!batches) return [];
  if (Array.isArray(batches)) {
    return batches.map(b => typeof b === 'string' ? b : (b.name || b));
  }
  if (typeof batches === 'string') {
    return batches.split(',').map(b => b.trim()).filter(b => b);
  }
  return [];
}

/**
 * Get session status display text
 */
export function getStatusText(state) {
  const stateLower = (state || 'pending').toLowerCase();
  switch (stateLower) {
    case 'marked':
      return 'Marked';
    case 'missed':
      return 'Missed';
    case 'cancelled':
      return 'Cancelled';
    default:
      return 'Pending';
  }
}




